import FederationTemplateConfig from "../template";
export default class FIPADefaultConfig extends FederationTemplateConfig {
    constructor() {
        super();
        this.webTitle = "FIPA";
        this.countryCode = "FI";
        this.links = {
            homepage: "https://www.ratsastus.fi/",
            news: "https://www.ratsastus.fi/ajankohtaista/",
            rulesPage: null
        };
        this.logo = {
            image: null,
            label: "KIPA",
            backgroundColor: "accent"
        };
    }
}
